module.exports = __webpack_public_path__ + "media/images/download-alternate-9613fb6c65b1d221f52b4c9f10c25592.svg";